import { connect } from 'react-redux';
import type { ActionCreator } from 'redux';
import { safeDifferenceInCalendarDays } from 'shared/util/datetime-fns';

import type { OverrideValues, AccommodationState } from '@/interfaces';
import { actions } from '@/state/filterActions';

import { fetchHotels } from '@/ducks/searchResults/actions';
import { RangeSlider, type RangeSliderDispatchProps, type RangeSliderStateProps } from '@/components/rangeSlider/RangeSlider';
import type { Attributes } from 'react';

export const roundDownToClosestThousand = (price: number): number => Math.floor(price / 1000) * 1000;

export const mapStateToProps = (state: AccommodationState): RangeSliderStateProps & Attributes => {
    const nightsSearched = safeDifferenceInCalendarDays(state.filters.checkInDate, state.filters.checkOutDate) ?? 1;
    const lowestRate = state.searchResults.lowestTotalRate ?? 0;
    const highestRate = state.searchResults.highestTotalRate ?? 2000 * nightsSearched;
    const min = roundDownToClosestThousand(lowestRate);
    const max = roundDownToClosestThousand(highestRate);
    return {
        id: 'PriceFilter',
        label: 'Totalpris',
        min,
        max,
        stepSize: 50 * nightsSearched,
        initialValues: state.filters.price,
        resetOnDefault: true,
        metric: 'kr',
        displayLabel: false,
        key: `PriceFilter-${min}-${max}`,
    };
};

export const mapDispatchToProps: OverrideValues<RangeSliderDispatchProps, ActionCreator<unknown>> = {
    onChange: actions.filterPrice,
    triggerFetch: fetchHotels,
};

export default connect(mapStateToProps, mapDispatchToProps)(RangeSlider);
